import React, { useState } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { Menu, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import envConfig from '../../../envConfig';

function LanguagePicker({ className }) {
  const languages = [
    {
      key: 'en',
      lang: 'en',
      name: 'English',
    },
    {
      key: 'es',
      lang: 'es',
      name: 'Español',
    },
  ];
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const changeLanguage = function (lang) {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang).then(() => {
      window.localStorage.setItem(
        `${envConfig.StoragePrefix}-lang`,
        JSON.stringify(lang)
      );
    });
  };
  return (
    <Menu as="div" className={`${className} relative`}>
      <Menu.Button
        aria-label="language"
        className="flex h-10 w-10 items-center justify-center rounded-lg text-2xl text-muted transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-gold-600 ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400"
      >
        <FontAwesomeIcon icon={faLanguage} />
      </Menu.Button>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-150"
        enterFrom="opacity-0 -translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-1"
      >
        <Menu.Items className="absolute right-0 z-20 mt-2 w-40 overflow-hidden rounded-xl border border-line bg-surface p-1.5 shadow-pop ring-0 outline-none focus:outline-none">
          {_.map(languages, (lang) => (
            <Menu.Item
              as="button"
              key={lang.key}
              type="button"
              onClick={() => changeLanguage(lang.lang)}
              className={`${selectedLanguage === lang.lang ? 'bg-gold-50 text-gold-700 font-semibold' : 'text-muted'} flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors duration-150 ease-in-out hover:bg-gold-50 hover:text-gold-700 ring-0 outline-none focus:outline-none`}
            >
              <FontAwesomeIcon icon={faLanguage} className="text-lg" />
              <span>{lang.name}</span>
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default LanguagePicker;
